var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"images_box_banner"},[_c('img',{attrs:{"src":_vm.imgObj.url,"width":_vm.imgObj.width,"height":_vm.imgObj.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }